import { C as a } from "./component-B88NZlIm.js";
import { d } from "./utilities-D-QcnR4L.js";
class h extends a {
  #e = null;
  connectedCallback() {
    (super.connectedCallback(),
      this.getAttribute("data-menu-mode") === "click" &&
        ((this.dropdowns = this.querySelectorAll("[data-dropdown]")), this.initClickMode()),
      this.positionMegaMenus());
  }
  disconnectedCallback() {
    (super.disconnectedCallback(), this.#e && (this.#e.disconnect(), (this.#e = null)));
  }
  positionMegaMenus() {
    const e = this.querySelectorAll(".dropdown-menu.fixed");
    if (e.length === 0) return;
    const t = () => {
      const n =
        document.querySelector('section[class*="header"]') ||
        document.querySelector("#shopify-section-header");
      if (!n) return;
      const o = n.querySelector(".container > div.flex");
      if (!o) return;
      const r = o.getBoundingClientRect().top,
        i = o.offsetHeight,
        c = r + i;
      e.forEach((l) => {
        l.style.top = `${c}px`;
      });
    };
    (t(),
      window.addEventListener("resize", t, { signal: this.signal }),
      (this.#e = new ResizeObserver(t)));
    const s =
      document.querySelector('section[class*="header"]') ||
      document.querySelector("#shopify-section-header");
    s && this.#e.observe(s);
  }
  initClickMode() {
    (this.dropdowns.forEach((e) => {
      const t = e.querySelector(".dropdown-toggle");
      t &&
        t.addEventListener(
          "click",
          (s) => {
            (s.preventDefault(),
              s.stopPropagation(),
              e.parentElement.querySelectorAll("[data-dropdown]").forEach((o) => {
                o !== e && o.classList.remove("is-open");
              }),
              e.classList.toggle("is-open"));
          },
          { signal: this.signal }
        );
    }),
      document.addEventListener(
        "click",
        (e) => {
          e.target.closest("[data-dropdown]") || this.closeAllDropdowns();
        },
        { signal: this.signal }
      ));
  }
  closeAllDropdowns() {
    this.querySelectorAll("[data-dropdown]").forEach((t) => {
      t.classList.remove("is-open");
    });
  }
}
d("dropdown-menu-component", h);
